export const InternationalCallStatusCssClasses = ["danger", "success", "info", ""];
export const InternationalCallStatusTitles = ["Suspended", "Active", "Pending", ""];
export const InternationalCallTypeCssClasses = ["success", "primary", ""];
export const InternationalCallTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "250", value: 250 },
  { text: "50", value: 50 },
  { text: "30", value: 30 },
  { text: "20", value: 20 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filterBy: [],
  orderBy: [],
  // sortOrder: "asc", // asc||desc
  // sortField: "id",
  search: "",
  page: 0,
  pageSize: 500
};
